import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/schoolStatistic/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/schoolStatistic/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/schoolStatistic/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/schoolStatistic/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/schoolStatistic/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/schoolStatistic/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/schoolStatistic/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/schoolStatistic/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/schoolStatistic/update/batch',
    method: 'POST',
    data})
}

   